import React from 'react'
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core'
import useStyles from '../../styles/styles'
import { FiEdit3, FiX } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import State from '../../states/State'

const columns = [
  { 
    field: 'id', 
    headerName: 'Extra', 
    width: 150 
  },
  {
    field: 'amount',
    headerName: 'Amount',
    type: 'number',
    width: 300,
  },
  {
    field: 'itemise',
    headerName: 'Itemise',
    width: 150,
  },
]

type ExtraRowProps = {
  readonly row: any;
  readonly extra: any;
  readonly updateExtra: any;
}

const ExtraRow: React.FC<ExtraRowProps> = ({ extra, row, updateExtra }) => {
  const classes = useStyles();
  const [isSelect, setIsSelect] = React.useState(extra.hasOwnProperty(row.part_number));
  const [isEdit, setIsEdit] = React.useState(false);
  const [isItemise, setIsItemise] = React.useState(extra.hasOwnProperty(row.part_number) ? extra[row.part_number].isItemise : true);
  const [cost, setCost] = React.useState(extra.hasOwnProperty(row.part_number) ? extra[row.part_number].cost : row.cost);

  const rowSelectHandler = (event: any) => {
    if (Boolean(event.target.checked)) setIsItemise(true);
    setIsSelect(event.target.checked);
  }

  const amountChangeHandle = (event: any) => {
    setCost(event.target.value);
  }

  const editOnClickHandle = () => {
    setIsEdit((prev) => !prev);
  }

  const itemiseSelectHanlder = (event: any) => {
    setIsItemise(event.target.checked);
  }

  React.useEffect(() => {
    if (Boolean(isSelect)) {
      updateExtra({
        ...extra,
        [row.part_number]: {
          name: row.name,
          cost: cost,
          isItemise: isItemise,
        }
      });
    } else {
      extra.hasOwnProperty(row.part_number) && updateExtra(delete extra[row.part_number]);
    }
    // eslint-disable-next-line
  }, [isSelect, isItemise, cost]);

  return <TableRow>
    <TableCell align="left" variant="body" style={{width: '60%'}}>
        <FormControlLabel
            className={classes.unselectable}
            control={
                <Checkbox
                    checked={isSelect}
                    name={row.part_number}
                    color="primary"
                    onClick={event => rowSelectHandler(event)}
                />
            }
            label={row.name}
        />
    </TableCell>
    <TableCell align="left" variant="body" padding="none" style={{width: '30%'}}>
        <TextField
            className={classes.amountInput}
            type="number"
            id={`price_${row.part_number}`}
            name={`price_${row.part_number}`}
            value={parseFloat(cost)}
            onChange={amountChangeHandle}
            disabled={!isSelect || (isSelect && !isEdit)}
            variant="outlined"
            fullWidth={false}
            size="small"
        />
        {isSelect &&  <IconButton onClick={editOnClickHandle} style={{fontSize: '20px', marginTop: '7px'}}>
            {isEdit ? <FiX id={`edit_price_${row.part_number}`} /> : <FiEdit3 id={`edit_price_${row.part_number}`} />}
        </IconButton>}
    </TableCell>
    <TableCell align="left" variant="body" padding="none">
        {isSelect && <Checkbox
            id={row.part_number + '_itemise'}
            color="primary"
            checked={isItemise}
            onClick={event => itemiseSelectHanlder(event)}
        /> }
    </TableCell>
  </TableRow>
}

type PeInstallationExtraProps = {
  readonly tmpItem: any;
  readonly setTmpItem: any;
}

const PeInstallationExtra: React.FC<PeInstallationExtraProps> = ({ tmpItem, setTmpItem }) => {
  const classes = useStyles();
  const state = useSelector((state: State) => ({
    daikins: state.shell.productData?.daikins,
  }));
  const { dk_extra } = state.daikins;

  const updateExtra = (tmpExtra: any) => {
    setTmpItem({
      ...tmpItem,
      item: {
        ...tmpItem.item,
        extras: tmpExtra,
      }
    });
  }

  return <div style={{ marginTop: 20 }}>
    <TableContainer component={Paper} className={classes.table}>
      <Table aria-label="caption table">
        <TableHead>
          <TableRow>
            {columns.map((column: any, index: any) => (
            <TableCell key={index} align="left" width={column.width}>
              {column.headerName}
            </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {dk_extra.map((row: any, index: any) => {
            return <ExtraRow key={index} row={row} extra={tmpItem.item.extras} updateExtra={updateExtra}/>
          })}
        </TableBody>
      </Table>
    </TableContainer>
  </div>
}

export default PeInstallationExtra